// Central content source for the Kuldeep Batra personal brand site
export const IMAGES = {
  // REAL portrait of Kuldeep Batra
  heroPortrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_finance-academy-pro/artifacts/58mjo2cu_Hero%20Image.png",
  aboutPortrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_finance-academy-pro/artifacts/58mjo2cu_Hero%20Image.png",
  programsBrochure:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_finance-academy-pro/artifacts/6n2weadq_Programs%20Available%20%282%29.png",
  corporateTraining:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  corporateTrainingAlt:
    "https://images.pexels.com/photos/8761336/pexels-photo-8761336.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  aiFinance:
    "https://images.pexels.com/photos/7108045/pexels-photo-7108045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  aiMesh:
    "https://images.pexels.com/photos/6203470/pexels-photo-6203470.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  courseCMA:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_finance-academy-pro/artifacts/qhj16o8b_FINANCIAL%20ACCOUNTING%20DESIGN.png",
  courseFinance:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_finance-academy-pro/artifacts/lnx45cyz_Advance%20Excel%20with%20AI.png",
  courseAI:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_finance-academy-pro/artifacts/1olur00w_AI%20Productivity%20Masterclass.png",
  courseCorporate:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_finance-academy-pro/artifacts/e1r2litv_Lead%20Forward%20Program.png",
  // Testimonial avatars
  avatar1: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop&crop=faces&q=85",
  avatar2: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=faces&q=85",
  avatar3: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=faces&q=85",
  avatar4: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=faces&q=85",
  avatar5: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=faces&q=85",
  avatar6: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&crop=faces&q=85",
  ytThumb1: "https://images.pexels.com/photos/6803540/pexels-photo-6803540.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ytThumb2: "https://images.pexels.com/photos/7947663/pexels-photo-7947663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ytThumb3: "https://images.pexels.com/photos/6238093/pexels-photo-6238093.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Verified stats only — 4th slot removed per client note (do not invent numbers)
export const STATS = [
  { value: "1,000+", label: "Students Mentored" },
  { value: "50+", label: "Corporate & Professional Training Sessions" },
  { value: "10+", label: "Institutions & Organizations Served" },
];

// Four compact trust points shown below hero CTAs
export const HERO_TRUST = [
  { icon: "GraduationCap", title: "Learn from Anywhere", body: "Live & Recorded" },
  { icon: "Briefcase", title: "Industry-Relevant", body: "Practical Learning" },
  { icon: "Users", title: "Mentorship That", body: "Transforms" },
  { icon: "Star", title: "Trusted by Thousands", body: "Across India" },
];

export const WHY_KB = [
  { icon: "Lightbulb", title: "Concept-First Learning", body: "Making complex subjects easier to understand." },
  { icon: "Target", title: "Practical Application", body: "Connecting knowledge with real-world situations." },
  { icon: "Rocket", title: "Future-Ready Skills", body: "Preparing learners for AI-driven workplaces." },
  { icon: "Compass", title: "Mentorship", body: "Helping students and professionals move forward with confidence." },
];

// Popular course tiles on Home
export const POPULAR_COURSES = [
  {
    id: "cma-inter",
    title: "CMA Intermediate",
    subtitle: "Group 1 & Group 2",
    image: "courseCMA",
    tag: "Live & Recorded",
    description: "Concept-first mastery for Financial and Corporate Accounting.",
    href: "/courses",
  },
  {
    id: "finance",
    title: "Finance & Accounting",
    subtitle: "For students & professionals",
    image: "courseFinance",
    tag: "Live & Recorded",
    description: "Build strong financial fundamentals for exams and career.",
    href: "/courses",
  },
  {
    id: "ai-all",
    title: "AI for Everyone",
    subtitle: "For students & professionals",
    image: "courseAI",
    tag: "Live & Recorded",
    description: "Practical AI skills for study, work and business impact.",
    href: "/courses",
  },
  {
    id: "corporate",
    title: "Corporate Training Programs",
    subtitle: "For teams & institutions",
    image: "courseCorporate",
    tag: "Customized",
    description: "AI, Excel, Finance and Leadership — tailored to your team.",
    href: "/courses",
  },
];

export const CMA_COURSES = [
  {
    id: "group-1-fa",
    group: "CMA Intermediate · Group 1",
    title: "Financial Accounting",
    subtitle: "Recorded Lectures",
    description:
      "A complete, concept-first mastery of Financial Accounting for CMA Intermediate. Chapter-wise structure with solved illustrations, revision capsules and exam-oriented problem drills.",
    type: "Recorded Video Course",
    duration: "Self-paced",
    language: "English + Hindi",
    mode: "Recorded",
    who_for: "CMA Intermediate students, commerce learners strengthening fundamentals",
    outcomes: [
      "Master core financial accounting concepts end-to-end",
      "Solve numericals with speed and accuracy",
      "Confidence for exam and interview scenarios",
      "Downloadable notes & revision capsules",
    ],
  },
  {
    id: "group-2-ca",
    group: "CMA Intermediate · Group 2",
    title: "Corporate Accounting",
    subtitle: "Recorded Lectures",
    description:
      "Corporate Accounting decoded from first principles to advanced application. Ideal for self-paced learners aiming for rank-worthy conceptual clarity and speed.",
    type: "Recorded Video Course",
    duration: "Self-paced",
    language: "English + Hindi",
    mode: "Recorded",
    who_for: "CMA Intermediate students, aspirants targeting ranks",
    outcomes: [
      "Company accounts, amalgamation & consolidation mastery",
      "Structured problem-solving frameworks",
      "Past-paper trend analysis and exam strategy",
      "Lifetime access, learn at your pace",
    ],
  },
];

// Featured corporate programs — sourced from the uploaded brochure
export const CORPORATE_PROGRAMS = [
  {
    id: "ai-productivity",
    title: "AI Productivity Masterclass",
    tag: "AI & Future Skills",
    icon: "Cpu",
    description: "Boost productivity with the power of AI.",
    long: "Learn practical AI tools to save time, automate tasks and work smarter.",
  },
  {
    id: "generative-ai",
    title: "Applied Generative AI",
    tag: "AI & Future Skills",
    icon: "Sparkles",
    description: "Learn, create and innovate with Generative AI tools.",
    long: "Master cutting-edge AI tools to create content, solve problems and innovate.",
  },
  {
    id: "excel-ai",
    title: "Microsoft Excel with AI",
    tag: "Data & Finance",
    icon: "LineChart",
    description: "From basics to advanced with AI & automation.",
    long: "Transform Excel into your most powerful business intelligence tool.",
  },
  {
    id: "leadforward",
    title: "LeadForward™",
    tag: "Leadership Development",
    icon: "Flag",
    description: "Creating leaders who drive results.",
    long: "Build confident leaders who inspire, influence and lead high-performing teams.",
  },
];

// LeadForward™ program levels (from brochure)
export const LEADFORWARD_LEVELS = [
  { id: "essentials", name: "LeadForward Essentials", audience: "Students & Freshers" },
  { id: "emerging", name: "LeadForward Emerging Leaders", audience: "First-Time Managers" },
  { id: "team", name: "LeadForward Team Leaders", audience: "Supervisors & Team Leads" },
  { id: "executive", name: "LeadForward Executive", audience: "Senior Managers & Business Leaders" },
];

export const LEADFORWARD_META = {
  duration: "1 Day Workshop (6 Hours)",
  ideal: "Students to Senior Business Leaders",
  mode: "Online · Offline · Hybrid",
  outcome: "Practical Tools, Action Plan & Certificate of Participation",
  pillars: ["Practical Frameworks", "Interactive Activities", "Real-Life Applications", "Measurable Impact"],
};

export const ABOUT_POINTS = [
  { title: "Associate Cost & Management Accountant (CMA)", body: "Professional credential in cost & management accounting." },
  { title: "10+ Years of Teaching Experience", body: "Mentoring students across India." },
  { title: "Corporate Trainer & Speaker", body: "Delivered 50+ sessions for organizations." },
  { title: "AI & Finance Expert", body: "Helping learners build future-ready skills." },
];

export const MANIFESTO = [
  { no: "01", title: "Clarity over complexity", body: "Great education is not about memorising — it is about understanding. Every concept is broken down to its first principle so it stays with you for life." },
  { no: "02", title: "Mentorship, not just teaching", body: "Beyond the syllabus, learners need direction. I mentor students and professionals to think, decide and lead — the way real careers demand." },
  { no: "03", title: "Future-ready skills", body: "The intersection of Finance, AI and Leadership is where the next decade will be won. I prepare people and organisations for that shift." },
];

export const TESTIMONIALS = [
  { name: "Ananya Sharma", role: "CMA Intermediate Student", achievement: "Cleared Group 1 in first attempt", photo: "avatar1", quote: "The way Sir explains Financial Accounting made every concept click. I finally understood the 'why' behind each entry — my scores jumped dramatically." },
  { name: "Rohit Verma", role: "L&D Head, Manufacturing Firm", achievement: "Rolled out AI training to 200+ team members", photo: "avatar2", quote: "The AI Productivity Masterclass transformed how our teams work. Practical, engaging and immediately applicable. One of the best corporate sessions we've hosted." },
  { name: "Dr. Meera Iyer", role: "Professor, Commerce Faculty", achievement: "Led faculty AI transformation", photo: "avatar3", quote: "Our Faculty Development Program was a turning point. The blend of pedagogy and modern AI tools was exactly what our department needed." },
  { name: "Karan Malhotra", role: "CMA Aspirant", achievement: "Ranked in top percentile in mocks", photo: "avatar4", quote: "Corporate Accounting felt impossible until these recorded lectures. Clear, structured and exam-focused. Worth every minute." },
  { name: "Sneha Kulkarni", role: "MSME Founder", achievement: "Scaled operations 2x in 12 months", photo: "avatar5", quote: "The MSME development program gave our small team the confidence and tools to scale. Genuinely life-changing guidance." },
  { name: "Amit Desai", role: "Finance Manager", achievement: "Automated 30+ finance workflows", photo: "avatar6", quote: "Excel with AI has permanently changed my workflow. I now do in minutes what used to take hours. Brilliant, hands-on teaching." },
];

export const FEATURED_IN = [
  { name: "ICMAI", note: "Institute Sessions" },
  { name: "NIRC", note: "Regional Council" },
  { name: "ICAI", note: "Guest Faculty" },
  { name: "ICSI", note: "Chapter Workshops" },
  { name: "Corporates", note: "In-house Training" },
  { name: "MSME Councils", note: "Development Programs" },
  { name: "Universities", note: "FDP & SDP" },
  { name: "Industry Webinars", note: "Keynote Speaker" },
];

export const YT_VIDEOS = [
  {
    id: "yt1",
    title: "How to Study for CMA with Job ? | Baap Strategy for CMA Aspirants",
    views: "",
    duration: "",
    thumb: "ytThumb1",
    url: "https://youtu.be/FLlDsE1aFmE?si=hjx0NKpDPwimzuTQ",
  },
];

export const YT_STATS = {
  subscribers: "10K+",
  videos: "100+",
  url: "https://youtu.be/FLlDsE1aFmE?si=WSwoJ95LhPqUrWvn",
};

export const BLOG_POSTS = [
  { id: "ai-finance-2025", title: "Why Every Finance Professional Must Learn AI Now", category: "AI & Finance", date: "Nov 2025", excerpt: "The finance function is being redefined. Here is a practical roadmap for professionals to stay indispensable in the age of AI.", read: "6 min read" },
  { id: "crack-cma-inter", title: "How to Crack CMA Intermediate: A Concept-First Strategy", category: "CMA Preparation", date: "Oct 2025", excerpt: "Marks follow understanding. A proven, structured approach to master Financial and Corporate Accounting with confidence.", read: "8 min read" },
  { id: "excel-ai-workflows", title: "5 Excel + AI Workflows That Save Hours Every Week", category: "Productivity", date: "Sep 2025", excerpt: "From automated analysis to instant reporting — simple, powerful workflows anyone can adopt today.", read: "5 min read" },
  { id: "leadership-mindset", title: "The Mentor's Mindset: Building Leaders, Not Followers", category: "Leadership", date: "Aug 2025", excerpt: "True development happens when people learn to think for themselves. Reflections from years of mentoring.", read: "4 min read" },
];

export const MEDIA_ITEMS = [
  { id: "m1", title: "AI Productivity Masterclass — Corporate Session", type: "Workshop", location: "Mumbai", image: IMAGES.corporateTraining },
  { id: "m2", title: "Faculty Development Program — University", type: "FDP", location: "Pune", image: IMAGES.corporateTrainingAlt },
  { id: "m3", title: "Applied Generative AI — Leadership Cohort", type: "Seminar", location: "Bengaluru", image: IMAGES.aiFinance },
  { id: "m4", title: "Excel with AI — Finance Teams", type: "Training", location: "Delhi NCR", image: IMAGES.aiMesh },
];

export const INQUIRY_TYPES = [
  "CMA Courses",
  "Corporate Training",
  "Faculty Development (FDP)",
  "Student Development (SDP)",
  "Institutional Partnership",
  "General",
];

// WhatsApp number & url (owner)
export const WHATSAPP_NUMBER = "918851400538";
export const OWNER_PHONE_DISPLAY = "+91 88514 00538";
export const OWNER_PHONE_TEL = "+918851400538";
export const OWNER_EMAIL = "Contact@Kuldeepbatra.com";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi, I'd like to know more about your CMA courses.")}`;
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/cmakuldeepbatra/",
  linkedin: "https://www.linkedin.com/in/kuldeepbatra/",
  youtube: "https://youtu.be/FLlDsE1aFmE?si=WSwoJ95LhPqUrWvn",
};
